import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BATamilLiteratureCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Tamil Literature",
    shortName: "B.A. Tamil",
    duration: "3 years",
    description: "Bachelor's degree program focused on Tamil language, literature, and cultural studies",
    overview: "Bachelor of Arts in Tamil Literature (B.A. Tamil) is a 3-year undergraduate program that provides comprehensive study of Tamil language, classical and modern literature, linguistics, and cultural heritage. This course covers ancient Tamil texts, modern literary works, poetry, drama, grammar, and literary criticism, preparing students for careers in education, literature, media, and cultural preservation.",
    eligibility: [
      "10+2 in any stream with Tamil as a subject",
      "Minimum 50% marks in 12th standard",
      "Basic proficiency in Tamil language",
      "Interest in literature and language studies"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Classical Tamil Literature",
          "Tamil Grammar",
          "Ancient Tamil Poetry",
          "Tamil Linguistics",
          "General English",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Modern Tamil Literature",
          "Tamil Drama and Theatre",
          "Comparative Literature",
          "Literary Criticism",
          "Tamil Prose",
          "Research Methodology"
        ]
      },
      {
        year: 3,
        subjects: [
          "Contemporary Tamil Writers",
          "Tamil Cultural Studies",
          "Translation Studies",
          "Folklore and Oral Traditions",
          "Project Work",
          "Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Tamil Teacher",
        "Content Writer",
        "Translator",
        "Journalist",
        "Cultural Officer",
        "Research Scholar",
        "Editor",
        "Script Writer",
        "Literary Critic",
        "Museum Curator"
      ],
      industries: [
        "Education Sector",
        "Media and Publishing",
        "Government Departments",
        "Cultural Organizations",
        "Translation Services",
        "Entertainment Industry",
        "Research Institutions",
        "Non-Profit Organizations",
        "Digital Content Creation",
        "Tourism Industry"
      ],
      averageSalary: "₹2-5 LPA (Fresher), ₹8-20 LPA (Experienced)",
      topRecruiters: [
        "Government Schools, Colleges",
        "Tamil Nadu Government",
        "Doordarshan, All India Radio",
        "Publishing Houses",
        "Cultural Institutions",
        "Translation Companies"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some colleges conduct entrance tests",
      "Direct admission in most colleges",
      "Reservation policies applicable",
      "Online application process"
    ],

    topColleges: [
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Premier Government College"
      },
      {
        name: "Madras Christian College",
        location: "Chennai",
        fees: "₹45,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹20,000",
        ranking: "State University"
      },
      {
        name: "Bharathiar University",
        location: "Coimbatore",
        fees: "₹25,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Tamil Language Proficiency",
      "Literary Analysis",
      "Creative Writing",
      "Translation Skills",
      "Research Methods",
      "Cultural Knowledge",
      "Communication Skills",
      "Critical Thinking",
      "Content Creation",
      "Academic Writing"
    ],

    futureScope: "Growing opportunities in digital content creation, Tamil cinema, cultural preservation, government positions, and increasing global interest in Tamil language and literature.",

    faqs: [
      {
        question: "What career options are available after B.A. Tamil Literature?",
        answer: "Career options include teaching, journalism, translation, content writing, government jobs, cultural organizations, and further studies like M.A. Tamil or B.Ed."
      },
      {
        question: "Can I pursue teaching after this course?",
        answer: "Yes, you can become a Tamil teacher after completing B.Ed., or teach at college level after M.A. Tamil and qualifying NET/SET exams."
      },
      {
        question: "Is there scope in media and entertainment?",
        answer: "Yes, opportunities exist in Tamil cinema, television, digital content, script writing, and Tamil media organizations."
      },
      {
        question: "Can I work in government after B.A. Tamil?",
        answer: "Yes, many government positions require Tamil language proficiency, especially in Tamil Nadu, and you can appear for various competitive exams."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BATamilLiteratureCoursePage;
